<template>
  <div>
    <div class="container1920">
      <div class="row">
        <div class="one whole">
          <img src="../assets/images/about/oldkv.jpg" class="block" />
        </div>
      </div>
    </div>
    <div class="container1920">
      <div class="row">
        <div class="one whole">
          <h1 class="titleH1 mbml">新闻中心</h1>

          <div class="news_all_main_menu mbll">
            <ul>
              <li style="padding: 8px 1%;">
                <a href="https://www.csvw.com/csvw-website/news/company-news.html">企业新闻</a>
              </li>

              <li style="padding: 8px 1%;">
                <a href="https://www.csvw.com/csvw-website/news/dz-brand-news.html">大众品牌新闻</a>
              </li>

              <li style="padding: 8px 1%;">
                <a href="https://www.csvw.com/csvw-website/news/audi-brand-news.html">奥迪品牌新闻</a>
              </li>

              <li style="padding: 8px 1%;">
                <a href="https://www.csvw.com/csvw-website/news/skoda-brand-news.html">斯柯达品牌新闻</a>
              </li>

              <li class="active" style="padding: 8px 1%;">
                <a href="https://www.csvw.com/subject/subjectList">专题报道</a>
              </li>

              <li style="padding: 8px 1%;">
                <a href="https://www.csvw.com/svwmedia-website/index/" target="_blank">媒体中心</a>
              </li>

              <li class="last" style="padding: 8px 1%;">
                <a href="https://www.csvw.com/csvw-website/news/company-bulletin.html">企业公告</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headNews",
  components: {},
  mounted: function() {},
  methods: {}
};
</script>

<style scoped src="../assets/less/about.css"></style>
<style scoped src="../assets/less/groundwork.css"></style>
<style scoped src="../assets/less/main.css"></style>
<style scoped src="../assets/less/swiper.min.css"></style>